import { createAsyncThunk } from '@reduxjs/toolkit';
import { formatHubGptApiMessage } from 'chatspot-core/messages/api/formatHubGptApiMessages';
import { getSalesCopilotThreadMessages } from '../api/hubGptApi';
export const resumeSalesCopilotThread = createAsyncThunk('threads/resumeSalesCopilotThread', async request => {
  const {
    threadId
  } = request;
  const response = await getSalesCopilotThreadMessages(threadId);
  return {
    id: threadId,
    messages: {
      hasMore: false,
      offset: 0,
      results: response.messages.map(message => formatHubGptApiMessage({
        message
      })).reverse()
    }
  };
});